const $ = require('jquery');

const floatingLabels = function() {
	$('.js-float-label .input, .js-float-label .textarea, .js-float-label .select select').on({
		focus() {
			$(this)
				.closest('.js-float-label')
				.addClass('is-active');
		},
		focusout() {
			if (!$(this).val()) {
				$(this)
					.closest('.js-float-label')
					.removeClass('is-active');
			}
		},
		input() {
			//cancelAutofill fun isn't working anymore with chrome's internal-autofill-selected awesomeness
			//so lets do some more magic juggling :(
			setTimeout(() => {
				if ($(this).is(':-internal-autofill-selected')) {
					var clone = $(this).clone(true, true);
					$(this).after(clone);
					$(this).remove();
				}
			}, 10);
		}
	});

	function checkAll() {

		$('.js-float-label:not(.is-active)').each(function() {
			const $this = $(this);
			if ($('.input, .textarea, .select select', $this).val()) {
				$this.addClass('is-active');
			}

			// Webkit autocompletes but doesn't actually change the val. So whe check for :-webkit-autofill via css animation-name.
			$(window).on('load', () => {
				setTimeout(() => {

					if (
						$('.input, .textarea, .select select', $this).css('animation-name') ==
						'cancelAutofill'
					) {
						$this.addClass('is-active');
					}
				}, 100);
			});
		});

	}

	checkAll();
};

const init = function() {
	floatingLabels();
};

module.exports = {
	init
};
